import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment.local';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StripeApi {
  http: HttpClient = inject(HttpClient);

  readonly STRIPE_URL: string = `${environment.apiUrl}/api/stripe`;

  createCheckoutSession(planId: number): Observable<{url: string}> {
    const dto: {planId: number} = {planId: planId}
    return this.http.post<{url: string}>(`${this.STRIPE_URL}/create-checkout-session`, dto);
  }

  createPortalSession(): Observable<{url: string}> {
    return this.http.post<{url: string}>(`${this.STRIPE_URL}/create-portal-session`, null);
  }

  createUpgradeSession(): Observable<{ url: string }> {
    return this.http.post<{ url: string }>(`${this.STRIPE_URL}/create-upgrade-session`, null);
  }
}
